module.exports = __webpack_public_path__ + "assets/GreenNoTex.2470170d03d7c072e6931d6f76452a64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/GreenNoTex.png
// module id = 1093
// module chunks = 0